export function stringifyObject(object: unknown, padding?: number) {
  return JSON.stringify(object, (key, value) => (typeof value === 'bigint' ? value.toString() : value), padding);
}
